// extracted by mini-css-extract-plugin
module.exports = {"icon":"Hint_icon__3rthI"};